import Crane from '../images/loading.png';
import Icon1 from '../images/planeicon.jpg';
import Icon2 from '../images/shipicon.jpg';
import Icon3 from '../images/truckicon.jpg';

export default function Loading(){
    return(
        <div>
            <div className="row map" style={{border: "1px solid lightgrey"}}>

                <div className="col-sm-6 bg-primary p-5">
                    <img src={Crane} className="crane" width="100%" alt="loading at 3Keys" />
                </div>

                <div className="col-sm-6">
                    <div>
                        <h2 className="text-center" style={{paddingTop:"100px", fontWeight:"600"}}>We Handle Your Items with Care</h2>
                        <p className="text-center">You can trst us with your goods. We deliver peace of mind and safely.</p>
                    </div>
                    <div className="row">
                        <div className="col-sm-4 pt-5 text-center">
                            <img src={Icon1} alt="3 keys plane icon" />
                            <p>We operate air freight for both International and local transit. We deliver fast.</p>
                        </div>

                        <div className="col-sm-4 pt-5 text-center">
                            <img src={Icon2} alt="3 keys ship icon" />
                            <p>We move your bulky or heavy items through the sea according to your preference.</p>
                        </div>

                        <div className="col-sm-4 pt-5 text-center">
                            <img src={Icon3} alt="3 keys truck icon" />
                            <p>Most movements within the country are usually carried out using our fleet of trucks.</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}